import { BenchmarkingIndexValues, overwriteItemResponse, queryInput } from 'API';
import OrderModal from 'components/Main/table/OrderModal';
import PreviewModal from 'components/Main/table/PreviewModal';
import { useCampaignContext } from 'context/CampaignContext';
import { values } from 'lodash';
import React, { useContext, useCallback } from 'react';
import { useEffect, useState } from 'react';
import { useTable, useSortBy } from 'react-table';
import styled from 'styled-components';
import { CommentsContext } from 'context/CommentsContext';
import InputContext from 'context/InputContext';
import { useHTML2Canvas } from 'customHooks/useHTML2Canvas';
import { placeholderFullSources } from './PlaceholderContainer';
import { useClientContext } from 'context/ClientContext';
import AuthContext from 'context/AuthContext';
export const Styles = styled.div`
  max-width: 100%;
  overflow-x: scroll;
  //   border: 1px solid blue;

  &::-webkit-scrollbar {
    background-color: ${({ theme }) => theme.placeholderBackground};
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.scrollThumb};
  }
  input {
    font-size: 12px;
    padding: 8px;
    border-radius: 7px;
    width: 20vw;
    border: 1px solid ${({ theme }) => theme.border};
    color: ${({ theme }) => theme.primaryGray};
  }
  textarea:focus,
  input:focus {
    outline: 1px solid ${({ theme }) => theme.primaryGray};
  }

  .title {
    font-family: 'FontRegular';
    font-size: 1.2vw;
    margin: 1vw 0;
    margin-left: 1vw;
  }
  .overwrittenDisclaimer {
    float: right;
    font-size: 0.7vw;
  }
  /* max-width: 100%; */
  /* width: 100%; */
`;

export const TableExport = styled.table`
  display: none;
  table {
    border-collapse: collapse;
    /* min-width: 92vw; */

    .number {
      text-align: right;
    }
    .string {
      text-align: left;
    }
  }

  tr {
    font-family: 'FontRegular', sans-serif;
    white-space: nowrap;
    color: ${({ theme }) => theme.primaryGray};
    border-bottom: 1px solid ${({ theme }) => theme.border};
  }

  tbody > tr > td {
    padding: 3px;
    font-size: 8px;
    color: ${({ theme }) => theme.primaryGray};
    font-family: 'FontRegular', sans-serif;
    border-bottom: 1px solid ${({ theme }) => theme.border};
    border-collapse: collapse;
  }
  th,
  tbody > tr:nth-last-child(1) > td {
    color: ${({ theme }) => theme.primaryGray};
    font-size: 12px;
    font-family: 'FontBold', sans-serif;
    border-bottom: none;
  }
  th {
    /* padding: 12px; */
    font-size: 12px;
  }
  tr:hover > td {
    background-color: ${({ theme }) => theme.background};
  }
  thead > tr > th {
    border-bottom: 1px solid ${({ theme }) => theme.border};
    border-collapse: collapse;
    padding: 5px 3px;
  }
`;

type Props = {
  data: any;
  page: any;
  title: any;
  setTitle(title: any): any;
  conversionsData: any;
  userMainQuery: any;
  userCCQuery: any;
  componentID?: string;
  handleChanges?(secondQuery: any, currentConversionsQueryCOPY: any, benchmarkQuery?: any): any;
  latestOverwrittenData?: overwriteItemResponse[] | undefined;
  saveCustomReport?: () => void;
  userBenchmarkQuery?: any;
  selectedDataSource?: placeholderFullSources | undefined;
  benchmarkIndex?: BenchmarkingIndexValues | null;
  setBenchmarkIndex?: (value: BenchmarkingIndexValues | null) => void;
  hideTotal?: boolean;
  setHideTotal?: (value: boolean) => void;
};

const DataTable = (props: Props) => {
  const columnData: any[] = [];
  const { testUser } = useContext(AuthContext);

  const { dashType } = useCampaignContext();
  const { activeOrganization } = useClientContext();
  const [displayOrderModal, setDisplayOrderModal] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [clickedHeader, setClickedHeader] = useState();
  const [activeObject, setActiveObject] = useState<any>();
  const [currentQueryCOPY, setCurrentQueryCOPY] = useState<queryInput | undefined>(undefined);
  const [mainReference, setMainReference] = useState<queryInput | undefined>(undefined);
  const [testObject, setTestObject] = useState<any>(undefined);
  const [currentConversionsQueryCOPY, setCurrentConversionsQueryCOPY] = useState<queryInput | undefined>(undefined);
  const [currentBenchmarkQueryCOPY, setCurrentBenchmarkQueryCOPY] = useState<any | undefined>(undefined);

  const [displayOrderConversionsModal, setDisplayOrderConversionsrModal] = useState(false);
  const { commentsList } = useContext(CommentsContext);
  const { capture, updatePPT } = useContext(InputContext);
  // console.log('AHA', props.data);

  // Helper function to find benchmark column name
  const getBenchmarkColumnName = (data: any[]) => {
    if (data.length === 0) return null;
    // Get benchmark column that ends with just " benchmark" (not " benchmark %")
    return Object.keys(data[0]).find((key) => key.endsWith(' benchmark')) || null;
  };

  // Helper function to calculate rowSpan for benchmark column
  const calculateBenchmarkRowSpans = (data: any[]) => {
    const rowSpans: { [key: number]: number } = {};
    const skipRows: Set<number> = new Set();

    if (data.length === 0) return { rowSpans, skipRows };

    // Remove the CPM/Cost logic from here - moved to useEffect below

    const benchmarkColumnName = getBenchmarkColumnName(data);
    if (!benchmarkColumnName) return { rowSpans, skipRows };

    // Helper function to identify if a row is a footer/total row
    const isFooterRow = (row: any) => {
      // Footer rows typically have no string values except campaign_id
      const hasStringValue = Object.entries(row).some(
        ([key, value]) =>
          key !== 'campaign_id' && // Ignore campaign_id as it can be string in footer
          typeof value === 'string' &&
          value !== '' &&
          value !== '-',
      );
      return !hasStringValue;
    };

    // Simplified approach: merge consecutive rows with identical benchmark values
    for (let i = 0; i < data.length; i++) {
      if (skipRows.has(i)) continue;

      const currentRow = data[i];
      const benchmarkValue = currentRow[benchmarkColumnName];

      // Skip if benchmark value is undefined, null, or '-'
      if (benchmarkValue === undefined || benchmarkValue === null || benchmarkValue === '-') {
        rowSpans[i] = 1;
        continue;
      }

      // If this is a footer row, don't merge it with anything
      if (isFooterRow(currentRow)) {
        rowSpans[i] = 1;
        continue;
      }

      // Count consecutive rows with the same benchmark value
      let spanCount = 1;
      for (let j = i + 1; j < data.length; j++) {
        const nextRow = data[j];
        const nextBenchmarkValue = nextRow[benchmarkColumnName];

        // Stop if we hit a footer row
        if (isFooterRow(nextRow)) {
          break;
        }

        // Only merge if benchmark values are identical (both valid numbers and equal)
        if (
          nextBenchmarkValue !== undefined &&
          nextBenchmarkValue !== null &&
          nextBenchmarkValue !== '-' &&
          nextBenchmarkValue === benchmarkValue
        ) {
          spanCount++;
          skipRows.add(j);
        } else {
          break; // Stop at first different value
        }
      }

      rowSpans[i] = spanCount;
    }

    return { rowSpans, skipRows };
  };
  props.data?.forEach((element: any) => {
    /*     element &&  */ Object.keys(element).forEach(function (k) {
      if (element[k] === 'Infinity' || element[k] === 'NaN') {
        element[k] = '-';
      }
    });
  });

  const headers = [] as any[];

  // Memoize temData to avoid recreating on every render
  const temData = React.useMemo(() => {
    let dataToProcess = [...props.data];

    // Handle CPM/Cost removal for specific component and organization
    if (
      props.componentID === 'BVOD1.1' &&
      activeOrganization?.OrganizationId === 'STAB#NO' &&
      dataToProcess.length > 0
    ) {
      console.log('EXECUTING CPM/Cost removal for', props.componentID);
      dataToProcess.forEach((obj) => {
        delete obj['CPM'];
        // delete obj['Cost'];
      });
    }

    return dataToProcess;
  }, [props.data, props.componentID, activeOrganization?.OrganizationId]);

  if (dashType === 'TV' /* && props.componentID && !props.componentID?.startsWith('BVOD') */) {
    const lookupTable = [
      'Bauer Media National',
      'DRR',
      'TV 2',
      'TV 2 News',
      'Viaplay Group',
      'Discovery',
      'Discovery Networks',
      'Warner Bros Discovery',
      undefined,
    ];
    temData.sort((a: any, b: any) => lookupTable.indexOf(a.Station) - lookupTable.indexOf(b.Station));
  }
  // dodao sam ovaj every i gore jos jedan element &&

  if (temData.length > 0 /*  && temData.every((el: any) => el !== undefined) */) {
    const tempDataCopy = JSON.parse(JSON.stringify(temData));
    const mostkeys = tempDataCopy.sort((a: any, b: any) => Object.keys(b).length - Object.keys(a).length)[0];

    const alignArrays = Object.entries(mostkeys).map((el: any) =>
      el.map((element: any) => (element === null ? 0 : element)),
    );
    const alignObject = Object.fromEntries(alignArrays);

    Object.keys(mostkeys).forEach((key: any, i) => {
      headers.push(key);
      const object: any = {
        Header: key,
        accessor: (data: any) => data[key],
        Footer: (info: any) => {
          const total = React.useMemo(
            () =>
              info.rows.reduce(
                (sum: any, row: { values: { visits: any } }) => row.values[key as keyof typeof values] + sum,
                0,
              ),
            [info.rows],
          );
          return (
            <> {isNaN(total) ? '-' : new Intl.NumberFormat('en-DK', { maximumFractionDigits: 2 }).format(total)}</>
          );
        },
        kita: alignObject[key] === '-' ? 'number' : typeof alignObject[key],
      };
      columnData.push(object);
    });
  }

  const data = React.useMemo(() => temData, [temData]);
  const columns = React.useMemo(() => columnData, [temData]);

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({ columns, data }, useSortBy);

  // CREATE QUERY COPY
  useEffect(() => {
    if (props.userMainQuery) {
      setCurrentQueryCOPY(JSON.parse(JSON.stringify(props.userMainQuery)));
      const kopije = JSON.parse(JSON.stringify(props.userMainQuery));
      kopije.query.calculatedMetrics?.map((el: any) => Object.assign(el, { column: el.name }));
      setMainReference(kopije);

      const testingStuff = JSON.parse(JSON.stringify(props.userMainQuery))?.query.metrics;
      testingStuff?.map((metric: any) => Object.assign(metric, { active: true }));
      setTestObject(testingStuff);
    }
  }, [props.userMainQuery]);

  // CREATE CONVERSIONS QUERY COPY
  useEffect(() => {
    if (props.userCCQuery) {
      setCurrentConversionsQueryCOPY(JSON.parse(JSON.stringify(props.userCCQuery)));
    }
  }, [props.userCCQuery]);

  // CREATE BENCHMARK QUERY COPY
  useEffect(() => {
    if (props.userBenchmarkQuery) {
      setCurrentBenchmarkQueryCOPY(JSON.parse(JSON.stringify(props.userBenchmarkQuery)));
    } else {
      setCurrentBenchmarkQueryCOPY(undefined);
    }
  }, [props.userBenchmarkQuery]);

  const openClose = (value: any) => {
    setActiveObject({});
    let QcalcMetrics = mainReference?.query.calculatedMetrics;
    let QMetrics = testObject;
    let QDimensions = currentQueryCOPY?.query.detailedDimensions;

    if (QcalcMetrics?.find((x: any) => x.name === value) !== undefined) {
      setActiveObject(QcalcMetrics.find((x: any) => x.name === value));
    } else if (QcalcMetrics?.find((x: any) => x.column === value) !== undefined) {
      setActiveObject(QcalcMetrics.find((x: any) => x.column === value));
    } else if (QMetrics?.find((x: any) => x.name === value) !== undefined) {
      setActiveObject(QMetrics.find((x: any) => x.name === value));
    } else if (QMetrics?.find((x: any) => x.column === value) !== undefined) {
      setActiveObject(QMetrics.find((x: any) => x.column === value));
    } else if (QDimensions?.find((x: any) => x.name === value) !== undefined) {
      setActiveObject(QDimensions.find((x: any) => x.name === value));
    } else if (QDimensions?.find((x: any) => x.column === value) !== undefined) {
      setActiveObject(QDimensions.find((x: any) => x.column === value));
    }
    setHidden(!hidden);
    setClickedHeader(value);
  };

  useEffect(() => {
    if (props.userCCQuery === undefined && currentQueryCOPY !== undefined) {
      const mainQueryChanged = JSON.stringify(props.userMainQuery) !== JSON.stringify(currentQueryCOPY);
      const benchmarkQueryChanged =
        props.userBenchmarkQuery && currentBenchmarkQueryCOPY
          ? JSON.stringify(props.userBenchmarkQuery) !== JSON.stringify(currentBenchmarkQueryCOPY)
          : Boolean(props.userBenchmarkQuery) !== Boolean(currentBenchmarkQueryCOPY);

      if (mainQueryChanged || benchmarkQueryChanged) {
        props.handleChanges &&
          props.handleChanges(currentQueryCOPY, currentConversionsQueryCOPY, currentBenchmarkQueryCOPY);
      }
    } else if (currentConversionsQueryCOPY !== undefined && currentQueryCOPY !== undefined) {
      const mainQueryChanged = JSON.stringify(props.userMainQuery) !== JSON.stringify(currentQueryCOPY);
      const ccQueryChanged = JSON.stringify(props.userCCQuery) !== JSON.stringify(currentConversionsQueryCOPY);
      const benchmarkQueryChanged =
        props.userBenchmarkQuery && currentBenchmarkQueryCOPY
          ? JSON.stringify(props.userBenchmarkQuery) !== JSON.stringify(currentBenchmarkQueryCOPY)
          : Boolean(props.userBenchmarkQuery) !== Boolean(currentBenchmarkQueryCOPY);

      if (mainQueryChanged || ccQueryChanged || benchmarkQueryChanged) {
        props.handleChanges &&
          props.handleChanges(currentQueryCOPY, currentConversionsQueryCOPY, currentBenchmarkQueryCOPY);
      }
    }
  }, [
    displayOrderModal,
    // currentQueryCOPY,
    // currentConversionsQueryCOPY,
    // currentBenchmarkQueryCOPY,
    // props.userMainQuery,
    // props.userCCQuery,
    // props.userBenchmarkQuery,
    // props.handleChanges,
    hidden,
  ]);

  const [edit, setEdit] = useState(false);

  const handleSave = () => {
    setEdit(!edit);
  };

  const tableRef: any = React.useRef();
  const returnObject = useHTML2Canvas(
    capture,
    tableRef.current,
    props.componentID as string,
    props.title,
    commentsList?.find((el) => el.placeholder === props.componentID)?.comment ?? '',
    columns,
    data,
  );
  useEffect(() => {
    if (returnObject) {
      // updatePDFelements(returnObject)
      updatePPT(returnObject);
      // updatePPT({ placeholder: props.componentID, table: tableRef.current })
    }
  }, [returnObject]);

  const pero = props.componentID;
  const nekiid = `id${props.componentID?.replace(/\./g, '0')}`;

  // const handlePPT = () => {
  //     let pptx = new pptxgen();
  //     pptx.tableToSlides(nekiid as string, { autoPage: true });
  //     pptx.writeFile({ fileName: "html2pptx-demo.pptx" });
  // }

  const TableforExport = (
    <TableExport id={nekiid} ref={tableRef} {...getTableProps()}>
      <thead>
        {headerGroups.map((headerGroup) => {
          return (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()} className={column.kita}>
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          );
        })}
      </thead>
      <tbody {...getTableBodyProps()}>
        {(() => {
          const { rowSpans, skipRows } = calculateBenchmarkRowSpans(temData);

          return rows.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <tr className="pero" {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  // Handle benchmark column with merged cells (only for basic benchmark columns, not % columns)
                  if (typeof cell.column.Header === 'string' && cell.column.Header.endsWith(' benchmark')) {
                    if (skipRows.has(rowIndex)) {
                      return null; // Skip this cell, it's merged with above
                    }

                    const rowSpan = rowSpans[rowIndex] || 1;
                    return (
                      <td
                        className={typeof cell.value !== 'string' || cell.value === '-' ? 'number' : 'string'}
                        {...cell.getCellProps()}
                        rowSpan={rowSpan > 1 ? rowSpan : undefined}
                        style={{
                          verticalAlign: 'middle',
                          textAlign: 'center',
                          // backgroundColor: rowSpan > 1 ? '#f8f9fa' : undefined
                        }}
                      >
                        {typeof cell.value !== 'number'
                          ? cell.render('Cell')
                          : new Intl.NumberFormat('en-DK').format(cell.value)}
                      </td>
                    );
                  }

                  // Regular cell rendering
                  return (
                    <td
                      className={typeof cell.value !== 'string' || cell.value === '-' ? 'number' : 'string'}
                      {...cell.getCellProps()}
                    >
                      {typeof cell.value !== 'number'
                        ? cell.render('Cell')
                        : new Intl.NumberFormat('en-DK').format(cell.value)}
                    </td>
                  );
                })}
              </tr>
            );
          });
        })()}
      </tbody>
    </TableExport>
  );
  const [somethingIsOverwritten, setSomethingIsOverwritten] = useState(false);
  const [reason, setReason] = useState('');
  const getIsMetricOverwritten = useCallback(
    (column: any) => {
      const metrics = props.userMainQuery?.query.metrics;
      const findMetric = metrics?.find((metric: any) => metric?.column === column);
      if (findMetric) {
        const metricColumn = findMetric.column;

        const result = props.latestOverwrittenData?.some((el) => el.Metric === metricColumn) ? true : false;

        return result;
      } else {
        return false;
      }
    },
    [props.userMainQuery?.query.metrics, props.latestOverwrittenData],
  );

  const getIsDimensionBenchmarkable = useCallback(
    (columnHeader: any) => {
      // First, find the dimension in detailedDimensions by name
      const detailedDimensions = props.userMainQuery?.query.detailedDimensions;
      const findDetailedDimension = detailedDimensions?.find((dimension: any) => dimension?.name === columnHeader);

      if (findDetailedDimension) {
        // Use the column property to search in selectedDataSource.dimensions
        const dimensionColumn = findDetailedDimension.column;
        const sourceDimension = props.selectedDataSource?.dimensions?.find(
          (dim: any) => dim?.dimension === dimensionColumn,
        );

        if (sourceDimension) {
          return sourceDimension.benchmarkable === true;
        }
      }

      return false;
    },
    [props.userMainQuery?.query.detailedDimensions, props.selectedDataSource?.dimensions],
  );

  useEffect(() => {
    const isOverwritten = columns.some((column) => getIsMetricOverwritten(column.Header));
    const reason =
      props.latestOverwrittenData && props.latestOverwrittenData?.length > 0
        ? props.latestOverwrittenData[0].Reason
        : '';
    reason && setReason(reason);

    isOverwritten && setSomethingIsOverwritten(isOverwritten);
  }, [columns, props.page, props.latestOverwrittenData, getIsMetricOverwritten]);
  const titleDefinition =
    dashType === 'FLOWCHART'
      ? props.title === ''
        ? 'Add title here'
        : props.title
      : props.title === 'Add title here' && props.page === 7
        ? ''
        : props.title;

  const customReportExtraStyle: React.CSSProperties = {
    height: '100%',
    display: 'flex',
    flexDirection: 'column' as const,
    overflowX: 'auto',
    overflowY: 'visible',
    position: 'relative',
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
    // Nested selectors aren't valid in React inline styles
    // WebkitScrollbar: { display: 'none' },
  };

  return props.data.length > 0 ? (
    <Styles style={props.saveCustomReport ? customReportExtraStyle : {}}>
      <div style={{ marginBottom: '1vw', textAlign: 'left' }}>
        {!edit && (
          <h1 className="title" onClick={() => (props.page === 6 ? setEdit(!edit) : null)}>
            {/* {props.title === 'Add title here' && props.page === 7 ? '' : props.title}{' '} */}
            {titleDefinition}
          </h1>
        )}

        {edit && (
          <h1 className="title">
            <input value={props.title} type="text" onChange={(e) => props.setTitle && props.setTitle(e.target.value)} />{' '}
            <button style={{ width: 'fit-content' }} type="button" onClick={handleSave}>
              SAVE
            </button>
          </h1>
        )}
      </div>
      {props.page === 6 && (
        <>
          <table {...getTableProps()}>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th
                      {...column.getHeaderProps()}
                      className={column.kita}
                      style={{
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        // color: getIsMetricOverwritten(column.render('Header')) ? 'red' : '',
                      }}
                      onClick={() => openClose(column.render('Header'))}
                    >
                      <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        {column.render('Header')}
                        {getIsMetricOverwritten(column.render('Header')) && <span style={{ color: 'red' }}>*</span>}
                        {getIsDimensionBenchmarkable(column.render('Header')) && (
                          <span
                            style={{
                              backgroundColor: '#4CAF50',
                              color: 'white',
                              fontSize: '10px',
                              padding: '1px 4px',
                              borderRadius: '3px',
                              fontWeight: 'bold',
                            }}
                            title="This dimension is benchmarkable"
                          >
                            B
                          </span>
                        )}
                      </span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {(() => {
                const { rowSpans, skipRows } = calculateBenchmarkRowSpans(temData);

                return rows.map((row, rowIndex) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => {
                        // Handle benchmark column with merged cells (only for basic benchmark columns, not % columns)
                        if (typeof cell.column.Header === 'string' && cell.column.Header.endsWith(' benchmark')) {
                          if (skipRows.has(rowIndex)) {
                            return null; // Skip this cell, it's merged with above
                          }

                          const rowSpan = rowSpans[rowIndex] || 1;
                          return (
                            <td
                              {...cell.getCellProps()}
                              className={typeof cell.value !== 'string' || cell.value === '-' ? 'number' : 'string'}
                              rowSpan={rowSpan > 1 ? rowSpan : undefined}
                              style={{
                                padding: '10px',
                                // verticalAlign: 'middle',
                                // textAlign: 'center',
                                // backgroundColor: rowSpan > 1 ? '#f8f9fa' : undefined,
                              }}
                            >
                              {typeof cell.value !== 'number'
                                ? cell.render('Cell')
                                : new Intl.NumberFormat('en-DK').format(cell.value)}
                            </td>
                          );
                        }

                        // Regular cell rendering
                        return (
                          <td
                            {...cell.getCellProps()}
                            className={typeof cell.value !== 'string' || cell.value === '-' ? 'number' : 'string'}
                            style={{
                              padding: '10px',
                            }}
                          >
                            {typeof cell.value !== 'number'
                              ? cell.render('Cell')
                              : new Intl.NumberFormat('en-DK').format(cell.value)}
                          </td>
                        );
                      })}
                    </tr>
                  );
                });
              })()}
            </tbody>
          </table>
          {somethingIsOverwritten && (
            <p className="overwrittenDisclaimer">*Data has been overwritten with the reason - "{reason}"</p>
          )}
          <button
            type="button"
            style={{ width: 'fit-content', fontSize: '.7vw', margin: '10px 5px' }}
            onClick={() => {
              setDisplayOrderModal(!displayOrderModal);
            }}
          >
            CHANGE COLUMN ORDER
          </button>
        </>
      )}

      {props.page === 7 && (
        <>
          <table ref={tableRef} {...getTableProps()}>
            <thead>
              {headerGroups.map((headerGroup) => {
                return (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column: any) => (
                      <th
                        {...column.getHeaderProps(column.getSortByToggleProps())}
                        className={column.kita}
                        style={{ cursor: 'pointer' }}
                      >
                        {`${column.render('Header')}${getIsMetricOverwritten(column.render('Header')) ? ' *' : ''}`}
                        <span style={{ marginLeft: '4px' }}>
                          {column.isSorted ? (column.isSortedDesc ? ' ▼' : ' ▲') : ''}
                        </span>
                      </th>
                    ))}
                  </tr>
                );
              })}
            </thead>
            <tbody {...getTableBodyProps()}>
              {(() => {
                const { rowSpans, skipRows } = calculateBenchmarkRowSpans(temData);

                // Identify footer/total row by checking if it was originally the last row AND has undefined values
                const isFooterRow = (row: any) => Object.values(row.original).some((value) => value === undefined);

                // Find footer row using original index (row.index is the index in original unsorted data)
                const lastOriginalIndex = temData.length - 1;
                const footerRow = rows.find((row) => row.index === lastOriginalIndex && isFooterRow(row));

                // Filter out the footer row from sorted rows
                const regularRows = footerRow ? rows.filter((row) => row !== footerRow) : rows;

                // Render regular rows (sorted)
                const renderedRows = regularRows.map((row, rowIndex) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()} key={row.id}>
                      {row.cells.map((cell, cellIndex) => {
                        // Handle benchmark column with merged cells (only for basic benchmark columns, not % columns)
                        if (typeof cell.column.Header === 'string' && cell.column.Header.endsWith(' benchmark')) {
                          if (skipRows.has(rowIndex)) {
                            return null; // Skip this cell, it's merged with above
                          }

                          const rowSpan = rowSpans[rowIndex] || 1;
                          return (
                            <td
                              {...cell.getCellProps()}
                              key={`${row.id}-${cellIndex}`}
                              className={typeof cell.value !== 'string' || cell.value === '-' ? 'number' : 'string'}
                              rowSpan={rowSpan > 1 ? rowSpan : undefined}
                              style={{}}
                            >
                              {typeof cell.value !== 'number'
                                ? cell.render('Cell')
                                : new Intl.NumberFormat('en-DK').format(cell.value)}
                            </td>
                          );
                        }

                        // Regular cell rendering
                        return (
                          <td
                            {...cell.getCellProps()}
                            key={`${row.id}-${cellIndex}`}
                            className={typeof cell.value !== 'string' || cell.value === '-' ? 'number' : 'string'}
                          >
                            {typeof cell.value !== 'number'
                              ? cell.render('Cell')
                              : new Intl.NumberFormat('en-DK').format(cell.value)}
                          </td>
                        );
                      })}
                    </tr>
                  );
                });

                // Render footer row at the end (always last, never sorted)
                if (footerRow) {
                  prepareRow(footerRow);
                  renderedRows.push(
                    <tr {...footerRow.getRowProps()} key="footer-row" className="footerIsBold">
                      {footerRow.cells.map((cell, cellIndex) => (
                        <td
                          {...cell.getCellProps()}
                          key={`footer-${cellIndex}`}
                          className={typeof cell.value !== 'string' || cell.value === '-' ? 'number' : 'string'}
                        >
                          {typeof cell.value !== 'number'
                            ? cell.render('Cell')
                            : new Intl.NumberFormat('en-DK').format(cell.value)}
                        </td>
                      ))}
                    </tr>,
                  );
                }

                return renderedRows;
              })()}
            </tbody>
          </table>
          {somethingIsOverwritten && (
            <p className="overwrittenDisclaimer">*Data has been overwritten with the reason - "{reason}"</p>
          )}
          {TableforExport}
        </>
      )}
      {hidden && (
        <PreviewModal
          hidden={hidden}
          openClose={openClose}
          activeObject={activeObject}
          data={props.data}
          clickedHeader={clickedHeader}
          mainReference={mainReference}
          currentQueryCOPY={currentQueryCOPY}
          currentQuery={props.userMainQuery}
          setCurrentQueryCOPY={(data: any) => setCurrentQueryCOPY(data)}
          testObject={testObject}
          currentConversionsQueryCOPY={currentConversionsQueryCOPY}
          currentConversionsQuery={props.userCCQuery}
          currentBenchmarkQueryCOPY={currentBenchmarkQueryCOPY}
          setCurrentBenchmarkQueryCOPY={(data: any) => setCurrentBenchmarkQueryCOPY(data)}
          selectedDataSource={props.selectedDataSource}
          // setChartMetrics={props.setChartMetrics}
          conversionsData={props.conversionsData}
          benchmarkIndex={props.benchmarkIndex}
          setBenchmarkIndex={props.setBenchmarkIndex}
          hideTotal={props.hideTotal}
          setHideTotal={props.setHideTotal}
        ></PreviewModal>
      )}
      {displayOrderModal && (
        <OrderModal
          displayOrderModal={displayOrderModal}
          setDisplayOrderModal={(toggle: any) => setDisplayOrderModal(toggle)}
          currentQueryCOPY={currentQueryCOPY}
          data={props.data}
        ></OrderModal>
      )}

      {/*  {displayOrderConversionsModal &&
                <OrderModalConversions
                    displayOrderConversionsModal={displayOrderConversionsModal}
                    setDisplayOrderConversionsrModal={(toggle: any) => setDisplayOrderConversionsrModal(toggle)}
                    currentConversionsQueryCOPY={currentConversionsQueryCOPY}
                    data={props.data}
                ></OrderModalConversions>
            } */}
    </Styles>
  ) : (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '2rem', color: '#888', fontSize: '14px', gap: '4px' }}>
      <span>THERE IS NO DATA TO DISPLAY.</span>
      <span>Please check your Campaign Mapping.</span>
    </div>
  );
};

export default DataTable;
